import { getElementExists } from "../helper/helper";

export function initNavIcon() {
  const navIcon = document.getElementById("mb-nav-icon");
  const mainMenuContainer = document.getElementById("mb-main-menu");
  const mainMenu = document.getElementById("menu-mainmenu");

  // Toggle nav with navicon
  if (getElementExists(navIcon)) {
    navIcon.addEventListener("click", function () {
      navIcon.classList.toggle("open");
      
      // Update aria-expanded attribute for accessibility
      const isExpanded = navIcon.getAttribute("aria-expanded") === "true";
      navIcon.setAttribute("aria-expanded", !isExpanded);

      if (getElementExists(mainMenuContainer)) {
        mainMenuContainer.classList.toggle("open");
        
        // Toggle body position to prevent scrolling when menu is open
        if (mainMenuContainer.classList.contains("open")) {
          document.body.style.position = "fixed";
          document.body.style.width = "100%";
        } else {
          document.body.style.position = "";
          document.body.style.width = "";
        }
      }
    });
  }

  // Toggle nav when nav item clicked
  if (getElementExists(mainMenu)) {
    const mainMenuItems = mainMenu.querySelectorAll(".menu-item");

    for (let i = 0; i < mainMenuItems.length; i++) {
      mainMenuItems[i].addEventListener("click", function (e) {
        if (e.target.classList.contains("dropdown-toggle")) return;

        // On mobile, don't close menu for items with children (they open submenus)
        if (window.innerWidth <= 1024 && this.classList.contains("menu-item-has-children")) {
          return;
        }

        if (getElementExists(navIcon)) {
          navIcon.classList.remove("open");
          navIcon.setAttribute("aria-expanded", "false");
        }

        if (getElementExists(mainMenuContainer)) {
          mainMenuContainer.classList.remove("open");
          
          // Reset body position when menu is closed
          document.body.style.position = "";
          document.body.style.width = "";
        }
      });
    }
  }
}
